import { useCostCentersQuery } from 'modules/budgets/apis';
import { unwrapQuery } from 'src/core/api/unwrapQuery';

import { useUser } from './useUser';

/**
 * Hook to determine if the current user is a budget owner (cost center owner).
 * A user is considered a budget owner if their ID matches the ownerId of any cost center.
 */
export const useBudgetOwnerRole = (): boolean => {
  const user = useUser();
  const costCentersQuery = useCostCentersQuery();
  const costCenters = unwrapQuery(costCentersQuery);

  return (
    costCenters?.some((costCenter) => costCenter.ownerId === user.id) || false
  );
};
